<template>
  <div class="d-flex full-form">
    <div class="d-md-flex w-100">
      <div class="item full-form__label">
        <label>{{ title }}</label>
      </div>
      <div class="item">
        <slot name="input" />
      </div>
    </div>
    <a
      :class="{'invisible': noIcon }"
      @click="$emit('info')"
    >
      <GjIcon
        class="icon-right full-form__icon"
        name="Info"
      />
    </a>
  </div>
</template>
<script>
export default {
  name: 'FormInput',
  props: {
    title: {
      type: String,
      default: null,
    },
    noIcon: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.full-form {
  .item {
    @media (min-width: 768px) {
      width: 50%;
    }
  }
  &__label {
    @media (max-width: 767px) {
      padding-left: 0;
    }
  }
}
</style>
